<template>
    <div>
        <HeaderComponent :pageContent="pageHeader" @change_language="handleHeaderClick"></HeaderComponent>
        <div class="container py-4">
            <div class="row">
                <div class="col-md-7">
                    <h2 class="fw-bold mb-2 colorText">Assessment & Data Tracking </h2>
                    <hr class="hr">
                </div>

                <div class="col-md-12">
                    <p class="colorText mb-4">
                        Discover a curated lineup of interactive assessment tools that make learning fun and feedback
                        instant.
                        Perfect for boosting engagement and tracking student progress with ease.
                    </p>
                </div>
            </div>


            <div class="row g-4 px-4">
                <!-- Edulastic -->
                <div class="col-md-6">
                    <div class="platform-card shadow-sm">
                        <a href="https://edulastic.teachable.com/" class="flex-shrink-1" target="_blank">
                            <img src="/assets/images/assessment_data_tracking/5.png" alt="Edulastic" />
                        </a>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1 colorText">Edulastic</h6>
                            <p class="mb-2 small colorText">
                                An online platform for creating standards-aligned assessments with auto-grading and real-time performance data.
                            </p>
                            <div class="d-flex justify-content-end">
                                <a href="https://edulastic.teachable.com/" target="_blank" class="btn btn-primary btn-sm">website</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Formative -->
                <div class="col-md-6">
                    <div class="platform-card shadow-sm">
                        <a href="https://www.formative.com/" class="flex-shrink-1" target="_blank">
                            <img src="/assets/images/assessment_data_tracking/6.png" alt="Formative" />
                        </a>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1 colorText">Formative</h6>
                            <p class="mb-2 small colorText">
                                A real-time tool for creating interactive assignments, tracking progress, and giving instant feedback.
                            </p>
                            <div class="d-flex justify-content-end">
                                <a href="https://www.formative.com/" target="_blank" class="btn btn-primary btn-sm">website</a>
                            </div>
                        </div>
                    </div>
                </div>




                <!-- Blooket -->
                <div class="col-md-6">
                    <div class="platform-card shadow-sm">
                        <a href="https://www.blooket.com/" class="flex-shrink-1" target="_blank">
                            <img src="/assets/images/assessment_data_tracking/7.png" alt="Blooket" />
                        </a>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1 colorText">Blooket</h6>
                            <p class="mb-2 small colorText">
                                A classroom review game platform where teachers host games and students compete by answering questions to earn points and rewards in fun, themed formats.
                            </p>
                            <div class="d-flex justify-content-end">
                                <a href="https://www.blooket.com/" target="_blank" class="btn btn-primary btn-sm">website</a>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Kahoot -->
                <div class="col-md-6">
                    <div class="platform-card shadow-sm">
                        <a href="https://kahoot.com/" class="flex-shrink-1" target="_blank">
                            <img src="/assets/images/assessment_data_tracking/8.png" alt="Kahoot" />
                        </a>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1 colorText">Kahoot!</h6>
                            <p class="mb-2 small colorText">
                                Game-based quizzes that are fun and fast-paced. Great for formative checks and reviews.
                            </p>
                            <div class="d-flex justify-content-end">
                                <a href="https://kahoot.com/" target="_blank" class="btn btn-primary btn-sm">website</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Quizizz -->
                <div class="col-md-6">
                    <div class="platform-card shadow-sm">
                        <a href="https://quizizz.com/" class="flex-shrink-1" target="_blank">
                            <img src="/assets/images/assessment_data_tracking/9.png" alt="Quizizz" />
                        </a>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1 colorText">Quizizz</h6>
                            <p class="mb-2 small colorText">
                                A gamified quiz platform that enables teachers to create quizzes for student practice, homework, or in-class engagement, with immediate feedback and detailed reports.
                            </p>
                            <div class="d-flex justify-content-end">
                                <a href="https://quizizz.com/" target="_blank" class="btn btn-primary btn-sm">website</a>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Google Forms -->

                <div class="col-md-6">
                    <div class="platform-card shadow-sm">
                        <a href="https://docs.google.com/" class="flex-shrink-1" target="_blank">
                            <img src="/assets/images/assessment_data_tracking/10.png" alt="Google Forms" />
                        </a>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1 colorText">Google Forms</h6>
                            <p class="mb-2 small colorText">
                                A flexible tool for quizzes, surveys, and quick checks for understanding. Auto-grades quizzes and collects data in Google Sheets for easy tracking.
                            </p>
                            <div class="d-flex justify-content-end">
                                <a href="https://docs.google.com/" target="_blank" class="btn btn-primary btn-sm">website</a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>




        <FooterComponent :pageContent="pageFooter"></FooterComponent>
    </div>
</template>
<style>
.colorText {
    color: #0c27bd;
}

.hr {
    border: 1px solid #0d6efd;
    border-radius: 5px;
}

.platform-card {
    border-radius: 12px;
    padding: 1rem;
    background-color: #ffff;
    display: flex;
    align-items: center;
    gap: 1rem;
}

/* .platform-card img {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: contain;
} */

.platform-card img {
    width: 60px;
    height: 60px;
    min-width: 60px;
    min-height: 60px;
    max-width: 60px;
    max-height: 60px;
    border-radius: 8px;
    object-fit: contain;
    flex-shrink: 0;
}


.platform-card .btn {
    font-size: 0.85rem;
    padding: 0.3rem 0.75rem;
}
</style>
<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
    name: "assessment-and-data-tracking",
    components: {
        HeaderComponent,
        FooterComponent,
    },
    data() {
        return {
            pageContent: [],
            pageHeader: [],
            pageFooter: [],
        }
    },
    mounted() {
        const storedLanguage = localStorage.getItem("language");
        if (storedLanguage) {
            this.language = storedLanguage;
        }
        this.convertLanguage();
    },
    methods: {
        openModal(url) {
            console.log(url);
            this.videoUrl = url;
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.videoUrl = "";
        },
        handleHeaderClick() {
            this.convertLanguage();
        },
        async convertLanguage() {
            const storedLanguage = localStorage.getItem("language");
            if (storedLanguage) {
                this.language = storedLanguage;
            }

            let lang = this.language;
            if (lang === "us") {
                lang = "en";
            }

            console.log("Updated content:", lang);

            const converted = globalMixins.class_room[lang];

            const pageHeader = globalMixins.pageHeader[lang];

            const pageFooter = globalMixins.pageFooter[lang];

            if (converted) {
                this.pageContent = {
                    ...this.pageContent,
                    ...converted,
                };

                this.pageHeader = {
                    ...this.pageHeader,
                    ...pageHeader,
                };

                this.pageFooter = {
                    ...this.pageFooter,
                    ...pageFooter,
                };
            }
        },
    },

};
</script>